import { SCOPES } from "shared/enums/common.enum";

export class Permission {
    id!: string;
    key!: string;
    scope!: SCOPES;
    tag!: string;
    companyId!: string;
    createdAt!: string;
    updatedAt!: string;
    RolePermission?: RolePermission;
    description!: string;

    constructor(data: Permission) {
        Object.assign(this, data);

        this.RolePermission = new RolePermission(data.RolePermission)
    }
}

export class RolePermission {
    id!: string;
    roleId!: string;
    permissionId!: string;
    createdAt!: string;
    updatedAt!: string;

    constructor(data?: Partial<RolePermission>) {
        Object.assign(this, data);
    }
}